// Copyright © 2021 Move Closer
import { Color } from '../_contracts';
export var StickyBarColor;
(function (StickyBarColor) {
    StickyBarColor[StickyBarColor["Black"] = Color.Black] = "Black";
    StickyBarColor[StickyBarColor["Blue"] = Color.Blue] = "Blue";
    StickyBarColor[StickyBarColor["Brand"] = Color.Brand] = "Brand";
    StickyBarColor[StickyBarColor["Gray"] = Color.Gray] = "Gray";
    StickyBarColor[StickyBarColor["Green"] = Color.Green] = "Green";
    StickyBarColor[StickyBarColor["Yellow"] = Color.CTA] = "Yellow";
})(StickyBarColor || (StickyBarColor = {}));
